import cn from 'classnames'

import useCopiedValue from '../../../hooks/use-copied-value'

import { CopyButtonWithSuccess } from '../copy-button-with-success'

import styles from './styles.module.scss'
import { InputWithCopyProps } from './input-with-copy.props'

export default function InputWithCopy({
  content,
  valueDisplay,
  className,
  isReadonly,
  isAllActive,
  inputClassName,
  ...props
}: InputWithCopyProps) {
  const [, handleCopy] = useCopiedValue()

  return isAllActive ? (
    <button
      {...props}
      className={cn(styles.button, styles.button_all, className)}
      type="button"
      onClick={handleCopy(content)}
    >
      {isReadonly ? (
        <input value={valueDisplay} readOnly className={inputClassName} />
      ) : (
        <input className={inputClassName} value={valueDisplay} />
      )}
      <CopyButtonWithSuccess value={content} className={styles.button__icon} />
    </button>
  ) : (
    <button {...props} className={cn(styles.button, className)} type="button">
      {isReadonly ? <input value={valueDisplay} readOnly /> : <input value={valueDisplay} />}
      <CopyButtonWithSuccess value={content} className={styles.button__icon} />
    </button>
  )
}
